import styled from "@emotion/styled";
import { css } from "@emotion/react";
import type { StylesObjectProps } from "utils/stylesObject";
import { mediaQuery } from "@hubble/web";

const deviceStyles = (
  device: "mobile" | "tablet" | "desktop",
  {
    background,
    border,
    borderRadius,
    boxSizing,
    display,
    flex,
    grid,
    gridArea,
    height,
    margin,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    padding,
    width,
    flexFlow,
    placeItems,
    placeContent,
    placeSelf,
    justifyContent,
    alignItems,
    alignContent,
    alignSelf,
    gap
  }: StylesObjectProps
) => css`
  ${background?.[device] ? `background: ${background[device]}; ` : ""}
  ${border?.[device] ? `border: ${border[device]}; ` : ""}
${borderRadius?.[device] ? `border-radius: ${borderRadius[device]}; ` : ""}
${boxSizing?.[device] ? `box-sizing: ${boxSizing[device]}; ` : ""}
${display?.[device] ? `display: ${display[device]}; ` : ""}
${flex?.[device] ? `flex: ${flex[device]}; ` : ""}
${grid?.[device] ? `grid: ${grid[device]}; ` : ""}
${gridArea?.[device] ? `grid-area: ${gridArea[device]}; ` : ""}
${height?.[device] ? `height: ${height[device]}; ` : ""}
${margin?.[device] ? `margin: ${margin[device]}; ` : ""}
${maxHeight?.[device] ? `max-height: ${maxHeight[device]}; ` : ""}
${maxWidth?.[device] ? `max-width: ${maxWidth[device]}; ` : ""}
${minHeight?.[device] ? `min-height: ${minHeight[device]}; ` : ""}
${minWidth?.[device] ? `min-width: ${minWidth[device]}; ` : ""}
${padding?.[device] ? `padding: ${padding[device]}; ` : ""}
${width?.[device] ? `width: ${width[device]}; ` : ""}
${flexFlow?.[device] ? `flex-flow: ${flexFlow[device]}; ` : ""}
${placeItems?.[device] ? `place-items: ${placeItems[device]}; ` : ""}
${placeContent?.[device] ? `place-content: ${placeContent[device]}; ` : ""}
${placeSelf?.[device] ? `place-self: ${placeSelf[device]}; ` : ""}
${justifyContent?.[device]
    ? `justify-content: ${justifyContent[device]}; `
    : ""}
${alignItems?.[device] ? `align-items: ${alignItems[device]}; ` : ""}
${alignContent?.[device] ? `align-content: ${alignContent[device]}; ` : ""}
${alignSelf?.[device] ? `align-self: ${alignSelf[device]}; ` : ""}
${gap?.[device] ? `gap: ${gap[device]}; ` : ""}
`;

export const baseComponentStyles = (args: StylesObjectProps) => css`
  ${deviceStyles("mobile", args)};
  @media ${mediaQuery.tabletSmUp} {
    ${deviceStyles("tablet", args)};
  }
  @media ${mediaQuery.desktopLgUp} {
    ${deviceStyles("desktop", args)}
  }
`;

export const BaseComponentWrapper = styled.div<StylesObjectProps>`
  ${(args: StylesObjectProps) => baseComponentStyles(args)}
`;
